import { PaginatedRequestParameters } from "@custom-types/utils"

export enum HTTP_STATUS {
  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  INVALID_CONTENT = 422,
  SERVER_ERROR = 500,
}

export const HTTP_ERROR_STATUSES = [
  HTTP_STATUS.BAD_REQUEST,
  HTTP_STATUS.FORBIDDEN,
  HTTP_STATUS.NOT_FOUND,
  HTTP_STATUS.CONFLICT,
  HTTP_STATUS.INVALID_CONTENT,
  HTTP_STATUS.SERVER_ERROR,
]

export type ValidationErrorPayload = {
  detail: ValidationError[]
}

type ValidationError = {
  type: string
  loc: string[]
  msg: string
  input: string
  ctx: { reason: string }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
export const isValidationErrorPayload = (payload: any): payload is ValidationErrorPayload => {
  return Array.isArray(payload?.detail)
}

export const parsePaginationParams = (params: PaginatedRequestParameters) => {
  if (!params) return {}

  const parsedParams: Record<string, string> = {}

  Object.entries(params).forEach(([key, value]) => {
    if (typeof value === "boolean") parsedParams[key] = (value as boolean).toString()
    else if (typeof value === "number") parsedParams[key] = Number(value).toString()
    else if (typeof value === "string") parsedParams[key] = value
  })

  return parsedParams
}
